import React from 'react'
import Select from 'react-select'
import {FormikErrors} from 'formik'

export function ReactSelectInput({
  isMulti = false,
  options = [],
  placeholder,
  label,
  required = false,
  onChange,
  value,
  disabled = false,
  error,
  isClearable = true,
}: ReactSelectInputProps) {
  return (
    <div className='my-1'>
      {label && <label className={`pb-1 fw-bold ${required ? 'required' : ''}`}>{label}</label>}
      <Select
        isClearable={isClearable}
        value={value}
        onChange={onChange}
        isMulti={isMulti}
        placeholder={placeholder}
        options={options}
        isDisabled={disabled}
        menuPosition="fixed"
        menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
        styles={{
          menuPortal: (base) => ({ 
            ...base, 
            zIndex: 99999 
          }),
          menu: (base) => ({ 
            ...base, 
            zIndex: 99999 
          }),
          control: (base) => ({
            ...base,
            ...(error ? { borderColor: '#dc3545' } : {}),
          }),
        }}
      />
      {error && (
        <div className='fv-plugins-message-container'>
          <div className='fv-help-block py-2'>
            <span className='text-danger fw-bold' role='alert'>
              {error}
            </span>
          </div>
        </div>
      )}
    </div>
  )
}

interface ReactSelectInputProps {
  isMulti?: boolean
  options?: {value: any; label: string | React.ReactNode}[]
  placeholder?: string | React.ReactNode
  label?: string | React.ReactNode
  required?: boolean
  onChange?: (value: any) => void
  value?: any
  disabled?: boolean
  error?: FormikErrors<string>
  isClearable?: boolean
}
